export const CHATBOT_TEXT = {
    askOurAI: 'Ask our AI powered by Moweb',
    inputPlaceholder: 'Ask about our services, requirements, pricing...',
    welcomeMessage:
        "Hi! I'm Moweb's AI assistant powered by Moweb. I can help you understand our AI enablement, enterprise software, and product engineering services. Let me know what you're looking for!",
    features: [
        'AI Enablement & Strategy',
        'Enterprise Software Development',
        'Product Engineering',
        'Cloud & Integration Solutions',
    ],
    title: 'Moweb AI Assistant',
    errorMessage: "I received your message but couldn't process it properly.",
    connectionErrorMessage: 'Connection issue. Please try again in a moment.',
    processingErrorMessage: 'I encountered an issue processing your message. Please try again or contact our team directly.',
    premiumHeaderText: 'Powered by Moweb • Enterprise AI Solutions',
    ragCapabilities: 'Our Capabilities',
    endChatConfirmation: 'Are you sure you want to end the chat? Your chat history will be permanently cleared.',
    endChatYes: 'Yes, End Chat',
    endChatCancel: 'Cancel',
    endingChat: 'Ending chat...',
};
